import React, { memo } from "react";
import ReactHtmlParser from "react-html-parser";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, Grid, Box, Tooltip, Typography } from "@mui/material";
import { Delete, Info } from "@mui/icons-material";
import { editOutput, deleteOutput, selectOutputById } from "./outputsSlice";
import { LineItem } from "../common/LineItem";

const WrappedComponent = ({ id }) => {
	const dispatch = useDispatch();
	const output = useSelector(state => selectOutputById(state, id));
	const { type } = output;
	const initial = (type === "cost" && id < 13) || (type === "weekly" && id < 25);

	const formatOutput = (output) => {
		const keys = Object.keys(output).filter((key) => (key !== "id" && key !== "type"));
		return keys.map((name) => {
			return {label: name, value: output[name], adornment: name !== "expense" && "$", readOnly: initial || name === "total"}
		});
	};

	const onChange = (e, label) => {
		const keys = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
		const value = label === "expense" ? e.target.value : e.target.value === "" ? 0.00 : parseFloat(e.target.value.replace(/,/g, ""));
		const tmpOutput = {...output, [label]: value};
		const total = type === "weekly" ? keys.reduce((a, v) => a + tmpOutput[v], 0) : undefined;
		dispatch(editOutput({id, changes: {[label]: value, ...(total && {total})}}));
	};

	const remove = (id) => {
		dispatch(deleteOutput(id));
	};

	return (
		<Grid container item spacing={1}>
			<Grid container item spacing={1} xs>
				{formatOutput(output).map(({ label, value, adornment, readOnly }, key) =>
					<Grid key={`expense_${key}`} item xs={label === "expense" ? type === "cost" ? 3 : 2 : true}>
						<Box sx={{height: "100%", width: "100%", display: "flex", alignItems: "center"}}>
							{(readOnly && label === "expense") && <Typography sx={{pl: 1.75, mr: 1}}>{ReactHtmlParser(value)}</Typography>}
							{(readOnly && value === 0.00 && initial) && <Typography align="right" sx={{width: "100%", pl: 1.75, mr: 2}}>——</Typography>}
							{!((readOnly && label === "expense") || (readOnly && value === 0.00 && initial))
								&& <LineItem {...{label, onChange, value, adornment, readOnly}} />
							}
							{(label === "expense" && value === "Light Touch labor") &&
								<Tooltip title="Light touch is Towels and Trash service" placement="top" arrow>
									<Info sx={{color: "secondary.main"}}/>
								</Tooltip>
							}
						</Box>
					</Grid>
				)}
			</Grid>
			<Grid item sx={{display: "flex", justifyContent: "center"}}>
				<IconButton sx={{border: "1px solid", visibility: initial ? "hidden" : "visible"}} color="error" onClick={() => remove(id)} disabled={initial}><Delete/></IconButton>
			</Grid>
		</Grid>
	);
};

export const OutputItem = memo(WrappedComponent);